<template>
	<div class="page-wrapper">
		<div class="page page-settings">
			<div class="container">
				<div class="page-header">
					<h1 class="page-title">
						<router-link class="text" to="/settings">Settings</router-link>
						<i class="separator material-icons">chevron_right</i>
						<span class="page-breadcrumb">Marketplace</span>
					</h1>
				</div>
				<div class="page-content">
					<!-- <div class="alert alert-warning" role="alert" v-if="isShowAlert('oo_account')">
						<i class="bi-info-circle-fill"></i> Untuk dapat menambahkan produk ke <b>OrderOnline.id</b> silahkan hubungkan akun anda.
					</div> -->

					<!-- List -->
					<div class="box p-0">
						<!-- Shopee -->
						<div class="integration-item">
							<div class="integration-app">
								<div class="wrapper">
									<div class="">
										<img
											src="/images/shopee-icon.svg"
											alt="Shopee"
											width="120"
										/>
									</div>
									<button
										type="button"
										class="integration-app-button btn btn-primary"
										@click="showAddStoreMarketplace('shopee')"
									>
										+ Add Shopee Account
									</button>
								</div>
							</div>
							<template v-if="isFetching">
								<div class="p-5">
									<loader :align="'center'"/>
								</div>
							</template>
							<template v-else>
								<div class="integration-accounts" v-if="shopeeShops.length !== 0">
									<div class="integration-account" v-for="(shopeeShop, index) in shopeeShops" :key="index">
										<div class="wrapper">
											<div class="integration-account__name">
												<div class="mb-1">
													<div class="d-flex align-items-center">
														<h5 class="mb-0">
															<b class="">
																{{ shopeeShop.store_label }}
															</b>
														</h5>
														<div class="pl-1">
															<span class="badge badge-success small">
																Connected
															</span>
														</div>
													</div>
													<div class="mt-2 small text-muted">
														Shop Name: {{ shopeeShop.shop_name }}
													</div>

												</div>
												<!-- address list -->
												<div class="mt-2">
													<div>
														<label for="">Address List</label>
													</div>
													<template v-if="shopeeShop.address_list && shopeeShop.address_list.length > 0">
														<div
															class="d-flex mb-3 pb-1 flex-column"
															v-for="(address, index) in shopeeShop.address_list"
															:key="index">
															<div class="d-flex flex-column">
																<div class="d-flex align-items-center">
																	<i class="material-icons">place</i> {{ address.address }} {{ address.district }} {{ address.city }} {{ address.province }} {{ address.zip_code }}
																</div>
																<div class="d-flex mt-1 ml-4">
																	<span class="badge badge-info mr-2" v-if="address.address_type && address.address_type.includes('PICKUP_ADDRESS')">
																		Pickup Address
																	</span>
																	<span class="badge badge-warning" v-if="address.address_type && address.address_type.includes('RETURN_ADDRESS')">
																		Return Address
																	</span>
																</div>
															</div>
														</div>
													</template>
												</div>
											</div>
											<div class="integration-account__actions">
												<button
													type="button"
													class="integration-account__remove btn-plain btn-icon-danger"
													:disabled="isDeletingShop"
													@click="showDeleteConfirmation(shopeeShop, 'Shopee')"
													v-tooltip="'Disconnect'"
												>
													<i class="material-icons">close</i>
												</button>
												<!-- <button type="button" class="integration-account__reconnect btn-plain btn-icon-danger" :class="{'is-loading' : isReconnecting}" @click="reconnect(account)" v-tooltip="'Reconnect'"><i class="material-icons">refresh</i></button> -->
											</div>
										</div>
									</div>
								</div>

								<div class="integration-accounts-empty p-4 text-center" v-if="shopeeShops.length === 0">
									No Shopee accounts connected yet.
								</div>
							</template>
						</div>
					</div>

				</div>
			</div>
		</div>
		<div class="modals">
			<add-store
				v-if="isAddMarketplaceStoreVisible"
				:title="selectedMarketplace.title"
				:alertText="selectedMarketplace.alertText"
				:omniType="selectedMarketplace.omniType"
				:omniChannelType="selectedMarketplace.omniChannelType"
				:isConnectingAccount="isConnectingAccount"
				@submit="connectNewStore"
				@close="isAddMarketplaceStoreVisible = false"
			/>

			<ModalLoadingIntegration
				v-if="isShowLoaderIntegration"
				@close="closeShopeeIntegrationModal"
			/>

			<ConfirmDisconnectModal
				:visible.sync="isShowDeleteConfirmation"
				:isLoading="isDeletingShop"
				:marketplaceName="selectedMarketplaceName"
				:shopLabel="selectedShopToDelete ? selectedShopToDelete.store_label : ''"
				@close="closeDeleteConfirmation"
				@confirm="disconnectShop"
			/>
		</div>

		<notifications group="autoresponder" position="bottom right" />
	</div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import Modal from '../components/Modal.vue';
import AddStore from '@/components/marketplace/AddStore'
import ModalLoadingIntegration from '@/components/marketplace/ModalLoadingIntegration'
import ConfirmDisconnectModal from '@/components/marketplace/ConfirmDisconnectModal'
import Loader from '@/components/Loader.vue';

import {
	getAxiosErrorMessage,
	getOS,
	getDeviceType,
	getBrowser,
	duplicateVar,
	isHasFeature,
} from '@/lib/helper';
import userApi from '@/api/user';
import {
	auth as shopeeAuth,
	getListShop,
	refreshToken,
	deleteShop,
} from '@/api/marketplace-shopee';

const base_url = process.env.VUE_APP_BASE_URL || 'https://app.ostock.id';

const marketplaces = [
	{
		key: 'shopee',
		title: 'Shopee',
		imageAlt: 'Shopee',
		alertText: 'Make sure the store you register is registered as a seller',
		omniType: 'Shopee',
		omniChannelType: 'shopee',
		isAlwaysShowButton: true,
	},
	// {
	// 	key: 'tokopedia',
	// 	title: 'Tokopedia',
	// 	text: '+ Add Account',
	// 	image: '/images/logo-tokopedia.svg',
	// 	imageAlt: 'Tokopedia',
	// 	alertText: 'Make sure the store you register is Power Merchant or Official Store',
	// 	omniType: 'Tokopedia',
	// 	omniChannelType: 'tokopedia',
	// 	isAlwaysShowButton: true,
	// },
];

export default {
	name: 'settingsAutoresponder',
	components: {
		Modal,
		AddStore,
		Loader,
		ModalLoadingIntegration,
		ConfirmDisconnectModal,
	},
	data() {
		return {
			isFetching: false,
			shopeeShops: [],
			isAddMarketplaceStoreVisible: false,
			selectedMarketplace: null,
			isConnectingAccount: false,
			page: 1,
			shop: null,
			limit: 25,
			sort_by: 'name',
			sort: 'asc',
			isShowLoaderIntegration: false,
			isShowDeleteConfirmation: false,
			selectedShopToDelete: null,
			selectedMarketplaceName: '',
			isDeletingShop: false,
		};
	},
	watch: {},
	methods: {
		showAddStoreMarketplace(key) {
			this.selectedMarketplace = marketplaces.find(
				marketplace => marketplace.key === key
			);
			this.isAddMarketplaceStoreVisible = true;
		},
		connectNewStore(store) {
			if (store.type === 'shopee') {
				this.addShopeeStore(store.storeLabel);
			}
			// if (store.type === 'tokopedia') {
			// 	this.addTokopediaStore(store.storeLabel, store.storeUrl);
			// }
		},
		addShopeeStore(storeLabel) {
			this.isConnectingAccount = true;
			const callback = (response) => {
				// console.log('response: ', response);
				this.isConnectingAccount = false;
				this.isAddMarketplaceStoreVisible = false;
				const url = response.data;
				if (url) {
					window.location.href = url;
				} else {
					this.$notify({
						group: 'app',
						title: 'Connecting Shopee Store Failed',
						text: 'No URL returned from server',
						type: 'error',
					});
				}
			};
			const errorCallback = (err) => {
				this.isConnectingAccount = false;
				const errorMessage = getAxiosErrorMessage(err);
				console.log('err conntecting store', errorMessage);
				this.$notify({
					group: 'app',
					title: 'Connecting Shopee Store Failed',
					text: errorMessage,
					type: 'error',
				});
			};

			const platform = 'shopee';
			shopeeAuth(platform, storeLabel, callback, errorCallback);
		},
		fetchListShop(reset = true) {
			// if (reset) {
			// 	this.resetListShop();
			// }
			const params = this.params;
			this.getListShop(params);
		},
		getListShop(params) {
			this.isFetching = true;
			const callback = (response) => {
				const shopeeShops = response.data.data || [];
				this.shopeeShops = shopeeShops;
				this.isFetching = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Error fetching shops',
					text: message,
				});
				this.isFetching = false;
			};
			getListShop(params, callback, errorCallback);
		},
		getConnectedStatus(platform = 'shopee', data) {
			let expiredAt = false;
			if (platform === 'shopee') {
				expiredAt = data.expired_at;
			}

			if (!expiredAt) {
				return false;
			}

			const expiredDate = new Date(expiredAt);
			const currentDate = new Date();

			const isNotExpired = expiredDate > currentDate;

			return isNotExpired;
		},
		getRefreshToken(platform = 'shopee', shopId) {
			let params = null;
			if (platform === 'shopee') {
				params = {
					'shop_id': shopId,
				}
			}

			const callback = (response) => {
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Token Refreshed',
					text: 'Successfully refreshed token',
				});
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Error refreshing token',
					text: message,
				});
			};
			refreshToken(params, callback, errorCallback);
		},
		checkShopeeIntegration() {
			const storeLabel = this.$route.query.store_label;
			const code = this.$route.query.code;
			const shopId = this.$route.query.shop_id;

			if (storeLabel && code && shopId) {
				this.isShowLoaderIntegration = true;
			}
		},
		closeShopeeIntegrationModal() {
			this.isShowLoaderIntegration = false;
			this.fetchListShop();
		},
		showDeleteConfirmation(shop, marketplaceName = 'Marketplace') {
			this.selectedShopToDelete = shop;
			this.selectedMarketplaceName = marketplaceName;
			this.isShowDeleteConfirmation = true;
		},
		closeDeleteConfirmation() {
			this.isShowDeleteConfirmation = false;
			this.selectedShopToDelete = null;
			this.selectedMarketplaceName = '';
		},
		disconnectShop() {
			if (!this.selectedShopToDelete) {
				return;
			}

			this.isDeletingShop = true;
			const payload = {
				id: this.selectedShopToDelete._id,
			};

			const callback = (response) => {
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Shop Disconnected',
					text: `Successfully disconnected ${this.selectedShopToDelete.store_label}`,
				});
				this.isDeletingShop = false;
				this.closeDeleteConfirmation();
				this.fetchListShop();
			};

			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Disconnect Failed',
					text: message,
				});
				this.isDeletingShop = false;
			};

			deleteShop(payload, callback, errorCallback);
		},
		isHasFeature,
	},
	computed: {
		...mapGetters({
			ooWeb: 'ooWeb',
			user: 'user',
			isOoLoggedIn: 'isOoLoggedIn',
			isDropshipper: 'isDropshipper',
		}),
		params() {
			const params = {
				page: this.page,
				limit: this.limit,
				sort_by: this.sort_by,
				sort: this.sort,
				is_approval: true,
			};
			return params;
		},
		connectedStatus() {
			return this.getConnectedStatus('shopee', this.shop);
		},
	},
	created() {
		if (!this.isFetching) {
			this.fetchListShop();
		}
	},
	mounted() {
		this.checkShopeeIntegration();
	}
};
</script>
